export default __webpack_public_path__ + "a01bcbd2c598faffa76b15a0996c803c.jpeg";